import React from "react";
import PropTypes from "prop-types";
import {
  withStyles,
  Card,
  CardHeader,
  Tabs,
  Tab
} from "material-ui";

// @material-ui/icons
import FiberNew from "@material-ui/icons/FiberNew";
import Stars from "@material-ui/icons/Stars";
import TrendingUp from "@material-ui/icons/TrendingUp";

import actionCardStyle from "assets/jss/material-dashboard-react/actionCardStyle";

class ActionCard extends React.Component {
  state = {
    value: 1
  };
  handleChange = (event, value) => {
    this.setState({ value });
  };
  render() {
    const { classes } = this.props;
    return (
      <Card className={classes.card}>
        <CardHeader
          classes={{
            root: classes.cardHeader,
            title: classes.cardTitle,
            content: classes.cardHeaderContent
          }}
          title="Sort:"
          action={
            <Tabs
              classes={{
                flexContainer: classes.tabsContainer,
                indicator: classes.displayNone
              }}
              value={this.state.value}
              onChange={this.handleChange}
              textColor="inherit"
            >
              <Tab
                classes={{
                  wrapper: classes.tabWrapper,
                  labelIcon: classes.labelIcon,
                  label: classes.label,
                  textColorInheritSelected: classes.textColorInheritSelected
                }}
                icon={<Stars className={classes.tabIcon} />}
                label="Popular"
                onClick={ e => this.props.sort('popular') }
              />
              <Tab
                classes={{
                  wrapper: classes.tabWrapper,
                  labelIcon: classes.labelIcon,
                  label: classes.label,
                  textColorInheritSelected: classes.textColorInheritSelected
                }}
                icon={<TrendingUp className={classes.tabIcon} />}
                label="Trending"
                onClick={ e => this.props.sort('hot') }
              />
              <Tab
                classes={{
                  wrapper: classes.tabWrapper,
                  labelIcon: classes.labelIcon,
                  label: classes.label,
                  textColorInheritSelected: classes.textColorInheritSelected
                }}
                icon={<FiberNew className={classes.tabIcon} />}
                label="New"
                onClick={ e => this.props.sort('new') }
              />
            </Tabs>
          }
        />
       
      </Card>
    );
  }
}

ActionCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(actionCardStyle)(ActionCard);



// WEBPACK FOOTER //
// ./src/components/Cards/ActionCard.jsx